import { render } from "./App.vue?vue&type=template&id=ebbd33b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ebbd33b0&lang=css"

import exportComponent from "/Users/nick/programming/udemy_vue/IFA_loud/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__